import { useCallback } from "react";
import { useDispatch } from "react-redux";
import useApi from "./useApi";
import { setSettings } from "../redux/settingsSlice";
import { getAllSystemSettingNew } from "../services/systemSettingService";
import { SYSTEMSETTINGS } from "../data/constants";
import { Setting } from "../types/Setting";
import { logHandledError } from "../utils/errorLogger";

interface RefreshSettingsOptions {
  /** For background refreshes the user did not trigger (e.g. a SignalR broadcast):
   * a failure is only logged, with no error popup and no useApi loading churn. */
  silent?: boolean;
}

/** Reloads the Portal-category settings into the Redux store that useSettingValue reads,
 * so a saved setting takes effect without the user having to log out and back in. */
export function useRefreshSettings({ silent = false }: RefreshSettingsOptions = {}) {
  const dispatch = useDispatch();
  const { executeApi } = useApi();

  return useCallback(async () => {
    let response: Setting[] | null;
    if (silent) {
      try {
        response = await getAllSystemSettingNew(SYSTEMSETTINGS.PORTAL_CATEGORY);
      } catch (err) {
        logHandledError((err as Error).message, (err as Error).stack ?? "");
        return;
      }
    } else {
      response = await executeApi<string, Setting[]>(
        getAllSystemSettingNew,
        SYSTEMSETTINGS.PORTAL_CATEGORY,
      );
    }
    if (response) {
      dispatch(setSettings(response));
    }
  }, [dispatch, executeApi, silent]);
}
